import { apiService } from '@/services/api'

export function useCatalogItem<T>(apiBase: string) {
  const sanitize = (payload: Partial<T>) => {
    const clone: Record<string, any> = { ...(payload as any) }
    delete clone.id
    delete clone.createdAt
    delete clone.updatedAt
    delete clone.deletedAt
    return clone as Partial<T>
  }
  const create = async (payload: Partial<T>) => {
    return apiService['request']<T>(`${apiBase}`, { method: 'POST', body: JSON.stringify(sanitize(payload)) })
  }
  const update = async (id: string, payload: Partial<T>) => {
    return apiService['request']<T>(`${apiBase}/${id}`, { method: 'PATCH', body: JSON.stringify(sanitize(payload)) })
  }
  const remove = async (id: string) => {
    return apiService['request']<{ success: boolean }>(`${apiBase}/${id}`, { method: 'DELETE' })
  }
  const restore = async (id: string) => {
    return apiService['request']<{ success: boolean }>(`${apiBase}/${id}/restore`, { method: 'POST' })
  }
  return { create, update, remove, restore }
}
